import styled from 'styled-components'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Alert } from '@h2/components/display/alert'
import { Container } from '@h2/components/layout/container'

import { clearUserFeedback } from '../actions/clearUserFeedback'
import { feedback as getFeedback } from '../selectors/feedback'

const Wrap = styled.div`
  padding: 15px 0;
`
/**
 * Global user feedback component.
 * Most likely will evolve into rendering toasts instead of alerts
 * so the message can be rendered in various page locations based
 * on the context of the component updating the redux store message.
 *
 * All depends on a global design which hasn't been provided.
 */
const Feedback = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const feedback = useSelector(getFeedback)

  useEffect(() => {
    const unlisten = history.listen(() => {
      dispatch(clearUserFeedback())
    })

    return () => unlisten()
  }, [history, dispatch])

  if (!feedback.msg) {
    return null
  }

  return (
    <Container>
      <Wrap>
        <Alert
          type={feedback.type}
          message={feedback.msg}
          onClose={() => dispatch(clearUserFeedback())}
        />
      </Wrap>
    </Container>
  )
}

export { Feedback }
